import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'RetornoStatus',
  props: {
    status: {}
  },
  setup(__props: any) {



var props = __props


function status(statusId: number){
    switch (statusId) {
        case 0:
            return "Pendente";
        case 1:
            return "Processando";
        case 2:
            return "Concluido";
        case 3:
            return "Erro";
        default:
            return "Desconhecido";
    }
}

// Define the icone function to return an icon based on status
function icone(statusId: number) {
    switch (statusId) {
        case 0:
            return "⏳";
        case 1:
            return "🔄";
        case 2:
            return "✅";
        case 3:
            return "❌";
        default:
            return "❓";
    }
}


function classeCor(statusId: number) {
    switch (statusId) {
        case 0:
            return "bg-primary";
        case 1:
            return "bg-warning";
        case 2:
            return "bg-success";
        case 3:
            return "bg-danger";
        default:
            return "bg-dark";
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["badge", classeCor(_unref(props).status)])
  }, _toDisplayString(icone(_unref(props).status)) + " " + _toDisplayString(status(_unref(props).status)), 3))
}
}

})